import { toast } from 'react-toastify';

import { confirmUserBlock } from '@vlabs/monokit/entities/users/confirm-user-block';
import { usePatchUser } from '@vlabs/api/artemy/client';

import { useBlockUserTranslation } from '../i18n';
import type { BlockUserProps } from '../types';

type UseBlockUserReturn = (() => Promise<void>) | undefined;

export function useBlockUser({
  userId,
}: BlockUserProps): UseBlockUserReturn {
  const { t } = useBlockUserTranslation();
  const blockUser = usePatchUser();

  return async (): Promise<void> => new Promise((resolve, reject) => {
    confirmUserBlock({
      userId,
      onConfirm: () => {
        blockUser.mutateAsync({
          userId,
          data: { status: 'blocked' },
        }, {
          onSuccess: () => {
            toast.success(t('toast_success'));
            resolve();
          },
          onError: () => {
            toast.error(t('toast_error'));
            reject();
          },
        });
      },
      onReject: reject,
    });
  });
}
